interface ScheduleItem {
  id: number;
  time: string;
  program: string;
  host?: string;
  icon: string;
}

export default function RadioSchedule() {
  const schedule: ScheduleItem[] = [
    {
      id: 1,
      time: '10:00 - 13:00',
      program: 'TOP 40 STAR',
      icon: 'ri-star-fill'
    },
    {
      id: 2,
      time: '13:00 - 16:00',
      program: 'ÉXITOS RADIO 2050',
      icon: 'ri-music-2-line'
    },
    {
      id: 3,
      time: '16:00 - 23:00',
      program: 'FÓRMULA 2050',
      icon: 'ri-radio-line'
    },
    {
      id: 4,
      time: '23:00 - 10:00',
      program: 'SMOOTH JAZZ NON STOP',
      icon: 'ri-headphone-line'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-purple-800/50 to-blue-800/50 backdrop-blur-sm rounded-3xl p-8 shadow-2xl border border-white/10">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-pink-500 rounded-full flex items-center justify-center">
          <i className="ri-calendar-schedule-line text-2xl text-white"></i>
        </div>
        <div>
          <h3 className="text-2xl font-bold text-white">Programación</h3>
          <p className="text-gray-300">RADIO 2050 ESPAÑA</p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {schedule.map((item) => (
          <div 
            key={item.id} 
            className={`bg-white/10 backdrop-blur-sm rounded-2xl p-5 hover:bg-white/15 transition-all border ${
              item.program === 'TOP 40 STAR' 
                ? 'border-yellow-400 bg-gradient-to-br from-yellow-400/20 to-pink-500/20' 
                : 'border-white/5'
            }`}
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
                item.program === 'TOP 40 STAR'
                  ? 'bg-gradient-to-br from-yellow-400 to-pink-500'
                  : 'bg-white/20'
              }`}>
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-yellow-400 font-semibold">{item.time}</span>
                  {item.program === 'TOP 40 STAR' && (
                    <span className="px-2 py-1 bg-gradient-to-r from-yellow-400 to-pink-500 text-white text-xs rounded-full font-bold">
                      EN VIVO
                    </span>
                  )}
                </div>
                <h4 className="text-white font-bold text-lg mb-1">{item.program}</h4>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
